






























































































































import Vue from 'vue'
import { getNestedValue } from '@/util/helpers'
import { TransactionsPriceSummary } from '@/interfaces/report/transactions'
import {
  transactionGroupsSummaries,
  transactionGroupDisabled,
} from '@/services/report/transactionGroup'

export default Vue.extend({
  computed: {
    valuationEditData() {
      return this.$store.getters['valuationEdit/data']
    },
    transactionDataset(): any {
      return getNestedValue(this.valuationEditData, ['transactionData'], {})
    },
    transactionSummaries(): TransactionsPriceSummary[] {
      return transactionGroupsSummaries(this.transactionDataset)
    },
    valuationPrice(): { m2: number; total: number } {
      return {
        m2: getNestedValue(this.valuationEditData, ['valuation', 'm2'], 0),
        total: getNestedValue(
          this.valuationEditData,
          ['valuation', 'total'],
          0
        ),
      }
    },
    modifiedValuationPrice(): { m2: number; total: number } {
      return {
        m2: getNestedValue(
          this.valuationEditData,
          ['modified', 'valuation', 'm2'],
          0
        ),
        total: getNestedValue(
          this.valuationEditData,
          ['modified', 'valuation', 'total'],
          0
        ),
      }
    },
    modifiedTransactionsCnt(): number {
      return getNestedValue(
        this.valuationEditData,
        ['modified', 'transactionsCnt'],
        0
      )
    },
    purchasePrice(): { m2: number; total: number; comparison: boolean } {
      return {
        m2: getNestedValue(
          this.valuationEditData,
          ['modified', 'purchasePrice', 'm2'],
          0
        ),
        total: getNestedValue(
          this.valuationEditData,
          ['modified', 'purchasePrice', 'total'],
          0
        ),
        comparison: getNestedValue(
          this.valuationEditData,
          ['modified', 'purchasePrice', 'comparison'],
          0
        ),
      }
    },
  },
  methods: {
    transactionGroupDisabled(transactionsKey: string): boolean {
      return transactionGroupDisabled(transactionsKey)
    },
    toggleTransactionGroup(transactionsKey: string) {
      const disabled = this.transactionGroupDisabled(transactionsKey)
      this.$store.commit('valuationEdit/addEdit', {
        categoryKey: 'transactionGroups',
        edit: {
          [transactionsKey]: disabled,
        },
      })
    },
  },
})
